import React from 'react'

import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'

import InviteUserForm from './form/invite-user-form'

type Props = {
  open: boolean
  onClose: () => void
}

const UserInviteDialog: React.FC<Props> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogHeader title="Invite a user" icon="person_add" onClose={onClose} />
    <InviteUserForm onSuccess={onClose} />
  </Dialog>
)

export default UserInviteDialog

export type { Props as UserInviteDialogProps }
